<template>
  <div class="containerTable">
    <vxe-toolbar id="toolbarId_bi1" :custom="{storage: true}" export :refresh="{query: RefreshList}">
      <template v-slot:buttons>
        <el-button @click="funcFilter">查询</el-button>
        <el-button @click="funcAdd">新增</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"     
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="partyGroupName" title="所属组织机构" min-width="100" sortable />
        <template v-slot:header>
          <partyGroupSelect ref="partyGroupSelect" style="width: 100%" @setPartyGroupCode="setPartyGroupCode" />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="forceTypeName" title="力别" min-width="100" sortable />
        <template v-slot:header>
          <el-select v-model="listQuery.forceTypeCode" placeholder="请选择力别  " clearable style="width:100%">
            <el-option
              v-for="item in forceTypeData"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column field="name" title="班组名称" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.name" placeholder="请输入班组名称" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="departmentName" title="所属部门" min-width="100" sortable :formatter="groupNameFormatter" />
        <template v-slot:header>
          <departmentSelect ref="departmentSelect" @setDepartmentCode="setDepartmentCode" />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" width="130">
        <template slot-scope="scope">
          <!-- <el-tooltip class="item" effect="dark" content="详情" placement="top">
            <vxe-button type="text" @click="funcDetail(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip> -->
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />

    <vxe-modal v-model="modelAddFlag" title="新增" width="500" height="500" resize>
      <compAdd ref="addRef" @fatherAddMethod="fatherAdd" @fatherCancelMethod="fatherCancel" />
    </vxe-modal>
    <vxe-modal v-model="modelEditFlag" title="编辑" width="500" height="500" resize>
      <compEdit ref="editRef" @fatherEditMethod="fatherEdit" @fatherCancelMethod="fatherCancel" />
    </vxe-modal>
    <!-- <vxe-modal v-model="modelDetailFlag" title="详情" width="500" height="500" resize>
      <compDetail ref="detailRef" />
    </vxe-modal> -->

  </div>
</template>
<script>
import compAdd from './components/teamAdd.vue'
import compEdit from './components/teamEdit.vue'
// import compDetail from './components/teamDetail.vue'
import request from '@/utils/request'
import departmentSelect from './components/departmentSelect.vue'
import partyGroupSelect from '@/views/components/partyGroupSelect.vue'

export default {
  name: 'TeamList',
  components: {
    compAdd,
    compEdit,
    // compDetail,
    partyGroupSelect,
    departmentSelect
  },
  data() {
    return {
      message: '',
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelDetailFlag: false,
      forceTypeData:[],

      copy: false,
      listQuery: {
        code: '',
        name: '',
        forceTypeCode:'',
        partyGroupCode: '',
        departmentCode: '',
        pageNum: 1,
        pageSize: 20,
        sortField: '',
        sortType: '',
        total: 0
      },
      Pagingconf: [],
      // 所属部門
      departmentList: []
    }
  },
  created() {
    this.getCascadeData()
    this.findForceType()
    this.getPartyGroup()

  },
  methods: {
    // 获取力别数据
    findForceType() {
      request({
        url: '/ntocc-wms-api/forceType/listForceType',
        method: 'get',
      }).then(response => {
        this.forceTypeData = response.data
      })
    },
    // 翻译力别
    formatterForceType({ cellValue }) {
      const sd = this.forceTypeData.find(i => i.code === cellValue)
      return sd ? sd.name : ''
    },


    //获取机构信息
    getPartyGroup() {
      request({
        url: '/ntocc-basic-api/partyGroup/getPartyGroup',
        method: 'get'
      }).then(response => {
        this.partyGroup = response.data
        this.$refs.partyGroupSelect.initData(this.partyGroup, 'setPartyGroupCode')
      }).then(response => {
        this.findList()
      })
    },
        // 选择组织机构
    setPartyGroupCode(value) {
      this.listQuery.partyGroupCode = value
    },

// 选择客户
    setDepartmentCode(value) {
        this.listQuery.partyGroupCode = value[0]
        this.listQuery.departmentCode = value[1]
    },
    groupNameFormatter({ row }) {
      let gropName = row.partyGroupName;
      if(row.departmentName)
        gropName =gropName + ' / ' + row.departmentName;
      return gropName
    },
    // 获取字典数据
    getCascadeData() {
      request({
        url: '/ntocc-basic-api/department/cascadeData',
        method: 'get'
      }).then(response => {
        this.cascadeData = response.data
        this.$refs.departmentSelect.initData(this.cascadeData, 'setDepartmentCode')
      }).then(response => {
        this.findList()
      })
    },

    findList() {
      return new Promise(resolve => {
        this.loading = true
        request({
          url: '/ntocc-basic-api/team',
          method: 'get',
          params: this.listQuery
        }).then(response => {
          resolve()
          this.tableData = response.data.records
          this.listQuery.total = response.data.total
          response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
          this.loading = false
        })
      })
    },
    // 添加方法
    funcAdd() {
      this.$refs.addRef.$refs.departmentSelect.initData(this.cascadeData, 'setDepartmentCode')
      this.modelAddFlag = true
    },
    // 修改方法
    funcEdit(code) {
      this.$refs.editRef.$refs.departmentSelect.initData(this.cascadeData, 'setDepartmentCode')
      this.$refs.editRef.getInfo(code)
      this.modelEditFlag = true
    },
    // 详情方法
    funcDetail(code) {
      this.$refs.detailRef.getInfo(code)
      this.modelDetailFlag = true
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm('确认删除吗？').then(_ => {
        request({ url: `/ntocc-basic-api/team`, method: 'delete', params: { codes: row }}).then(response => {
          this.$message({ message: response.msg, type: 'success' })
          this.findList()
        })
      }).catch(_ => {})
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false
      this.findList()
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false
      this.findList()
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case 'add':
          this.modelAddFlag = false
          break
        case 'edit':
          this.modelEditFlag = false
          break
        case 'detail':
          this.modelDetailFlag = false
          break
        default:
      }
    },
  }
}
</script>
<style>
    
</style>

